import React, { useEffect, useState } from "react";
import getClientService from "../../../services/getClientService";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import List from "./list";
import AddEdit from "./addEdit";

const Clients = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [client, setClient] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [filterVal, setFilterVal] = useState({
    pageNumber: 1,
    pageSize: 10,
    searchText: "",
    id: "",
    totalPages: 1,
  });

  const { searchText, pageNumber, pageSize } = filterVal;
  const fetchCleint = async () => {
    try {
      const list = await getClientService.GetClientListPage(filterVal);
      setFilterVal({ ...filterVal, totalPages: list.totalPages });
      setClient(list?.clients || []); // Set the data to state currentPage
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchCleint(); // Call fetchData initially when the component mounts
  }, [searchText, pageNumber, pageSize]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilterVal((prev) => ({
        ...prev,
        searchText: searchTerm,
        pageNumber: 1,
      }));
    }, 400); // ✅ Wait 400ms before making an API call

    return () => clearTimeout(delayDebounce); // ✅ Clear timeout if user keeps typing
  }, [searchTerm]); // ✅ Runs only when searchTerm changes

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleClickOpenAddDialog = () => {
    // Open Add Dialog
    setOpenAddDialog(true);
  };
  return (
    <div>
      <h3>Client List</h3>
      <div className="my-3 d-flex justify-content-between">
        <FormControl
          sx={{ m: 1, width: "25ch" }}
          variant="outlined"
          size="small"
        >
          <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type="text"
            name="search"
            value={filterVal.search}
            onChange={handleSearchChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" edge="end">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            label="search"
          />
        </FormControl>
        <FormControl
          sx={{ m: 2, width: "15ch" }}
          variant="outlined"
          size="small"
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClickOpenAddDialog}
          >
            + Add Client
          </Button>
        </FormControl>
      </div>
      <List
        client={client}
        fetchCleint={fetchCleint}
        filterVal={filterVal}
        setFilterVal={setFilterVal}
        setSelectedClient={setSelectedClient}
        setOpenAddDialog={setOpenAddDialog}
      />
      <AddEdit
        setOpenAddDialog={setOpenAddDialog}
        openAddDialog={openAddDialog}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        fetchCleint={fetchCleint}
      />
    </div>
  );
};

export default Clients;
